export default __webpack_public_path__ + "static/media/plus.0c3dcf35.svg";